import { render } from "./OfficeAddress.vue?vue&type=template&id=2bdaeab8"
import script from "./OfficeAddress.vue?vue&type=script&lang=js"
export * from "./OfficeAddress.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/pmanastacio/pmanastacio/apps/anastacio_site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__